import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getReportTemplateList } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import DeleteReportTemplateModal from './Delete/DeleteReportTemplate';
import AddEditReportTemplateModal from './Add_Edit/AddEditReportTemplateModal';

const ReportTemplateList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorReportTemplate = createSelector(
		state => state.Screen,
		report => ({
			reportTemplateList: report.reportTemplateList,
			isLoadingList: report.isLoadingList,
			isReportTemplateSuccess: report.isReportTemplateSuccess,
			error: report.error,
			isAdding: report.isAdding,
			isAdded: report.isAdded,
			isAddError: report.isAddError,
			isUpdating: report.isUpdating,
			isUpdated: report.isUpdated,
			isUpdateError: report.isUpdateError,
			isDeleting: report.isDeleting,
			isDeleted: report.isDeleted,
			isDeleteError: report.isDeleteError,
		})
	);

	const { reportTemplateList, isLoadingList } = useSelector(
		selectorReportTemplate
	);

	useEffect(() => {
		dispatch(getReportTemplateList());
	}, []);

	const [dataReportTemplate, setDataReportTemplate] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete ReportTemplate
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = report => {
		setDataReportTemplate(report);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = report => {
		setDataReportTemplate(report);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'report',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const reportData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(reportData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const reportData =
														cellProps.row.original;
													handleClickDelete(reportData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre de la plantilla', accessorKey: 'name',  size: 'auto' },
			{ header: 'Descripción', accessorKey: 'description',  size: 'auto' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataReportTemplate({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Generar Plantilla
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={reportTemplateList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={[
									{
										label: 'Generar',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataReportTemplate({});
											handleToggleModal();
										},
										title: 'Generar Plantilla'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditReportTemplateModal
				dataReportTemplate={dataReportTemplate}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteReportTemplateModal
				dataReportTemplate={dataReportTemplate}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ReportTemplateList;
